module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      visible: _vm.visible
    },
    attrs: {
      "id": "chooseconf"
    }
  }, [_c('div', {
    staticClass: "chooseconf_main bg-accent c-dark"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "h4 medium"
  }, [_vm._v(_vm._s(_vm.$t('welcome')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "h4 light"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t('intro')) + "\n\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "h6 light"
  }, [_c('br'), _c('br'), _vm._v("\n\t\t" + _vm._s(_vm.$t('warning_1')) + "\n\t\t"), _c('a', {
    staticClass: "regular",
    attrs: {
      "href": 'mailto:' + _vm.$store.state.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.email))]), _vm._v("\n\t\t" + _vm._s(_vm.$t('or'))), _c('a', {
    staticClass: "regular",
    attrs: {
      "href": _vm.$store.state.resellersLink,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('reseller')))]), _vm._v(" " + _vm._s(_vm.$t('warning_2')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "login_area"
  }, [(!_vm.loggedIn) ? _c('a', {
    staticClass: "h10 light regular",
    on: {
      "click": _vm.show_pop
    }
  }, [_vm._v(_vm._s(_vm.$t("login")))]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('a', {
    staticClass: "h10 light regular",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "chooseconf_cols"
  }, _vm._l((_vm.sections), function(section, index) {
    return _c('button', {
      ref: "section",
      refInFor: true,
      staticClass: "chooseconf_col bg-lgrey t-left",
      class: {
        extended: section.isSelected
      },
      on: {
        "click": function($event) {
          _vm.selectConfigurator(index)
        }
      }
    }, [_c('div', {
      ref: "text",
      refInFor: true,
      staticClass: "chooseconf_text"
    }, [_c('h2', {
      ref: "text_content",
      refInFor: true,
      staticClass: "h3 c-dark medium upcase"
    }, [_vm._v(_vm._s(section.name))]), _vm._v(" "), _c('h3', {
      ref: "text_sub",
      refInFor: true,
      staticClass: "h3 light c-dark"
    }, [_c('span', [_vm._v("SYSTEM")]), _vm._v(" "), _c('span', {
      staticClass: "h6"
    }, [_vm._v(_vm._s(section.subtitle))])])]), _vm._v(" "), _c('div', {
      ref: "layer",
      refInFor: true,
      staticClass: "chooseconf_layer bg-light"
    })])
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "showpopup"
    }
  }, [(_vm.popupVisible) ? _c('div', {
    staticClass: "sharepopup_container",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hidePopup($event)
      }
    }
  }, [_c('div', {
    staticClass: "sharepopup"
  }, [_c('span', {
    staticClass: "h7 medium c-dark upcase"
  }, [_vm._v(_vm._s(_vm.$t("login")))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h9 c-dgrey wrap"
  }, [_vm._v(_vm._s(_vm.$t("login_text")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u_email),
      expression: "u_email"
    }],
    staticClass: "shareinput h7 medium c-dark",
    attrs: {
      "type": "text",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.u_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.u_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u_password),
      expression: "u_password"
    }],
    staticClass: "shareinput h7 medium c-dark",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.u_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.u_password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "h7 medium c-dark upcaser"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "medium h7 c-accent upcase",
    on: {
      "click": _vm.set_auth
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t("send")) + "\n\t\t\t\t\t")])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "h2 medium"
  }, [_c('span', {
    staticClass: "c-light"
  }, [_vm._v("MY.")]), _vm._v("KRIPTONITE")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-693a727a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ChooseConf.vue
// module id = 641
// module chunks = 0